/**
 * Hotspot functionality for mobile click interactions
 */
export default function initHotspots() {
  const hotspotPins = document.querySelectorAll('.hotspot-pin')
  
  if (!hotspotPins.length) return
  
  hotspotPins.forEach((pin) => {
    const tooltip = pin.querySelector('.hotspot-tooltip')
    
    if (!tooltip) return
    
    // Handle click on pin for mobile
    pin.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      
      // Close other open tooltips
      hotspotPins.forEach((otherPin) => {
        if (otherPin !== pin) {
          otherPin.classList.remove('active')
        }
      })
      
      // Toggle this tooltip
      pin.classList.toggle('active')
    })
    
    // Prevent tooltip from closing when clicking inside it
    tooltip.addEventListener('click', (e) => {
      e.stopPropagation()
    })
  })
  
  // Close tooltips when clicking outside
  document.addEventListener('click', () => {
    hotspotPins.forEach((pin) => {
      pin.classList.remove('active')
    })
  })
}
